import Vue from 'vue'
import Router from 'vue-router'

/* Router Modules */
import BASIC_ROUTERS from './routes/basic'

Vue.use(Router)

//Router Modules内部相关参数注释
/** note: sub-menu only appear when children.length>=1
 *  detail see  https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 **/

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    will control the page roles (you can set multiple roles)
    title: 'title'               the name show in sub-menu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if true, the page will no be cached(default is false)
    breadcrumb: false            if false, the item will hidden in breadcrumb(default is true)
    affix: true                  if true, the tag will affix in the tags-view
  }
 **/

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [...BASIC_ROUTERS]

/**
 * asyncRoutes--动态挂载的页面路由
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = []

const createRouter = () =>
    new Router({
        // mode: 'history', // require service support
        // base: process.env.BASE_URL,
        routes: constantRoutes,
    })

/**
 * 路由重置
 * // Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
 * */

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher //reset router
}

const router = createRouter()

export default router

/*
const routes = [
    ...BASIC_ROUTERS,
];

let router = new Router({
    // mode: 'history', // require service support
    // base: process.env.BASE_URL,
    routes
});
export default router*/
